import { z } from "zod";
import { DateInputField } from "@/components/shared/form";
import { TenderType } from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { UseFormReturn } from "react-hook-form";
import { createDateSchema } from "@/utils/form";
import { getInputWidth } from "../../Shared/helpers";

export const createDeadlineSchema = (t: TFunction) => {
  return z.object({
    deadline: z.object({
      publication: createDateSchema(t).optional(),
      submission: createDateSchema(t),
      questions: createDateSchema(t).optional(),
      outsideInformation: createDateSchema(t).optional(),
      siteVisit: z.date({
        error: (issue) => issue.input === undefined ?
          t("schemas:createtender.deadline.daterequired")
          :
          t("schemas:createtender.deadline.dateinvalid"),
      }).refine((date) => date instanceof Date && !isNaN(date.getTime()), {
        message: t("schemas:createtender.deadline.dateinvalid"),
      }).optional(),
    }),
  });
};

export const deadlineDefaultValues = {
  deadline: {
    publication: undefined,
    submission: undefined,
    questions: undefined,
    outsideInformation: undefined,
    siteVisit: undefined,
  }
};

export function DeadlineFormGroup({ form, leftPanelWidth }: { form: UseFormReturn<any>, leftPanelWidth: number }) {
  const { t } = useTranslation();

  const formFields = [
    {
      name: "deadline.publication",
      label: t("newtender.formgroups.deadline.inputs.publication.label"),
      allowOlderDates: true,
      hideOnPrivate: true,
      className: getInputWidth(leftPanelWidth)
    },
    {
      name: "deadline.submission",
      label: t("newtender.formgroups.deadline.inputs.submission.label"),
      hideOnPrivate: false,
      className: getInputWidth(leftPanelWidth)
    },
    {
      name: "deadline.questions",
      label: t("newtender.formgroups.deadline.inputs.questions.label"),
      hideOnPrivate: true,
      className: getInputWidth(leftPanelWidth)
    },
    {
      name: "deadline.outsideInformation",
      label: t("newtender.formgroups.deadline.inputs.outsideinformation.label"),
      hideOnPrivate: false,
      showOptional: true,
      className: getInputWidth(leftPanelWidth)
    },
    {
      name: "deadline.siteVisit",
      label: t("newtender.formgroups.deadline.inputs.sitevisit.label"),
      hideOnPrivate: true,
      showOptional: true,
      className: getInputWidth(leftPanelWidth)
    },
  ];

  const tenderType = form.watch("description.type");

  return (
    <div id="deadline">
      {/* FormFields */}
      <div className="form-field-container">
        {
          formFields.map((field) => (
            (field.hideOnPrivate && tenderType === TenderType.Private) ? null : (
              <DateInputField
                key={field.name}
                form={form}
                name={field.name}
                label={field.label}
                allowOlderDates={field.allowOlderDates}
                showOptional={field.showOptional}
                className={field.className}
              />
            )
          ))
        }
      </div>
    </div>
  );
}
